export default __webpack_public_path__ + "972989a99f643a351fe1bc5cdffb0303.jpg";